var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.589,
    height: 55.362,
    viewBox: "0 0 64.589 55.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-assessment",
    "data-name": "Icon material-assessment",
    className: "cls-1",
    d: "M61.913,4.5H11.677C7.729,4.5,4.5,7.268,4.5,10.651V53.711c0,3.383,3.229,6.151,7.177,6.151H61.913c3.947,0,7.177-2.768,7.177-6.151V10.651C69.089,7.268,65.86,4.5,61.913,4.5ZM26.03,47.559H18.853V26.03H26.03Zm14.353,0H33.206V16.8h7.177Zm14.353,0H47.559v-12.3h7.177Z",
    transform: "translate(-4.5 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.4b78b39557e18a19041d9730e8882593.svg";
export { ForwardRef as ReactComponent };